import { render, staticRenderFns } from "./AlterarPreco.vue?vue&type=template&id=3303748c"
import script from "./AlterarPreco.vue?vue&type=script&lang=ts"
export * from "./AlterarPreco.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports